import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { API_ROUTES, apiUrl } from "../../../utils/http";
import { useDispatch } from "react-redux";
import {
  addCourseStudied,
  addCurrentInstitution,
  addGradeObtainedFromInstitution,
  addJambFirstChoice,
  addJambNumber,
  addJambSecondChoice,
  addJambSubjectScore,
  addTotalScore,
  appliedFirstJoice,
  appliedSecondJoice,
} from "../../../redux/reducers/features/applicant-data/jamb-info-slice";
import { validateJambNumber } from "../../../utils/validateDataEntry";
import { excludeSelectedOptions } from "../../../utils/selectExclusion";


export default function JambInformation({ onForwardClick, onPreviousClick }) {
  const dispatch = useDispatch();

  const [jambNumber, setJambNumber] = React.useState(""); //required
  // const [firstFaculty, setFirstFaculty] = React.useState(""); // Faculty removed
  const [firstDepartment, setFirstDepartment] = React.useState("");
  const [firstDepartments, setFirstDepartments] = React.useState([]);
  // const [secondFaculty, setSecondFaculty] = React.useState(""); // Faculty removed
  const [secondDepartment, setSecondDepartment] = React.useState("");
  const [secondDepartments, setSecondDepartments] = React.useState([]);
  const [currentInstitution, setCurrentInstitution] = React.useState('');
  const [courseStudied, setCourseStudied] = React.useState('');
  const [gradeObtainedFromInstitution, setGradeObtainedFromInstitution] = React.useState('')

  const [departments, setDepartments] = React.useState();
  // const [faculty, setFaculty] = React.useState(); // Faculty removed

  React.useEffect(() => {

    (async () => {
      try {
        const response = await fetch(apiUrl(API_ROUTES.department));
        const data = await response.json();

        console.log(data, "data==>");

        const departments = data?.data?.filter(dept => dept.name !== 'all');

        setDepartments(departments);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();

    // Faculty removed
    // (async () => {
    //   try {
    //     let endpoint;
    //     if (process.env.NODE_ENV === "development") {
    //       endpoint = `http://localhost:3000/api/faculty`;
    //     } else if (process.env.NODE_ENV === "production") {
    //       endpoint = "https://api.portal.madukauniversity.edu.ng/api/faculty";
    //     }
    //     const response = await fetch(endpoint);
    //     const data = await response.json();
    //     const faculties = data?.data?.filter(fac => fac.name !== 'all-faculties');
    //     setFaculty(faculties);
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // })();

  }, []);

  const handleForwardClick = () => {
    if (jambNumber && !validateJambNumber(jambNumber)) {
      toast.error('JAMB Number must be 12 digits followed by 2 letters');
      return
    }

    if (
      jambNumber &&
      firstDepartment &&
      // firstFaculty && // Faculty removed
      secondDepartment
      // && secondFaculty // Faculty removed
    ) {
      let data = {
        current_institution: currentInstitution,
        course_studied: courseStudied,
        grade_obtained_from_institution: gradeObtainedFromInstitution,
        jamb_number: jambNumber,

        applied_first_choice: {
          department: firstDepartment,
          // faculty: firstFaculty, // Faculty removed
        },
        applied_second_choice: {
          department: secondDepartment,
          // faculty: secondFaculty, // Faculty removed
        },
      };
      onForwardClick(data);
      dispatch(appliedSecondJoice(data.applied_second_choice));
      dispatch(appliedFirstJoice(data.applied_first_choice));
      dispatch(addTotalScore(data.jamb_total_score));
      dispatch(addJambSubjectScore(data.jamb_subject_scores));
      dispatch(addJambFirstChoice(data.jamb_first_choice));
      dispatch(addJambSecondChoice(data.jamb_second_choice));
      dispatch(addJambNumber(data.jamb_total_score));
      dispatch(addCourseStudied(data.course_studied));
      dispatch(addCurrentInstitution(data.current_institution));
      dispatch(addGradeObtainedFromInstitution(data.grade_obtained_from_institution))
    } else {
      toast.error("ensure all required fields are filled");
    }
  };


  // Faculty removed - departments were previously filtered by selected faculty:
  // const getFirstDepartments = () => {
  //   console.log("firstFaculty", firstFaculty);
  //   let filteredDepartments = departments?.filter(
  //     (item) => item?.faculty?._id === firstFaculty?._id
  //   );
  //   console.log("filteredDepartments", filteredDepartments);
  //   if (filteredDepartments) {
  //     setFirstDepartments(filteredDepartments);
  //   } else {
  //     setFirstDepartments([]);
  //   }
  // };
  // const getSecondDepartments = () => {
  //   let filteredDepartments = departments?.filter(
  //     (item) => item?.faculty?._id === secondFaculty
  //   );
  //   console.log("secondFaculty", secondFaculty);
  //   console.log("filteredDepartmentsfilteredDepartments", filteredDepartments);
  //   if (filteredDepartments) {
  //     setSecondDepartments(filteredDepartments);
  //   } else {
  //     setSecondDepartments([]);
  //   }
  // };

  React.useEffect(() => {
    setFirstDepartments(departments || []);
    setSecondDepartments(departments || []);
  }, [departments]);

  return (
    <Card sx={{ p: { xs: 0, lg: 3 }, mt: { xs: 1.8, lg: 3 } }}>
      <CardContent>
        <Typography
          variant="h6"
          component="h6"
          color="#00356B"
          sx={{ fontStyle: 'italic', margin: '1rem 0', fontSize: '25px', lineHeight: '30px', fontWeight: '500' }}
        >
          Details
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="JAMB Number"
                placeholder="Enter JAMB Number"
                variant="outlined"
                value={jambNumber}
                onChange={(e) => setJambNumber(e.target.value)}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Typography variant="body1" className="fw-bold mt-4 mb-3">
          Desired Department at Maduka University, Enugu
        </Typography>
        {/* Original heading: "Desired Department and Faculty at Maduka University, Enugu" - Faculty removed */}

        <Grid container spacing={2} sx={{ mt: -1.5 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select First Choice Department</InputLabel>
              <Select
                value={firstDepartment}
                onChange={(e) => {
                  const value = e.target.value;
                  setFirstDepartment(value);
                  if (secondDepartment === value) setSecondDepartment("");
                }}
                fullWidth
                label="First Choice Department"
              >
                {excludeSelectedOptions(firstDepartments, firstDepartment, [secondDepartment], (row) => row._id)?.map((row, index) => (
                  <MenuItem value={row._id} key={Math.random() + "-" + index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select Second Choice Department</InputLabel>
              <Select
                value={secondDepartment}
                onChange={(e) => {
                  const value = e.target.value;
                  setSecondDepartment(value);
                  if (firstDepartment === value) setFirstDepartment("");
                }}
                fullWidth
                label="Second Choice Department"
              >
                {excludeSelectedOptions(secondDepartments, secondDepartment, [firstDepartment], (row) => row._id)?.map((row, index) => (
                  <MenuItem value={row._id} key={row._id}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Faculty removed
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select First Choice Faculty</InputLabel>
              <Select
                value={firstFaculty}
                onChange={(e) => setFirstFaculty(e.target.value)}
                fullWidth
                label="First Choice Faculty"
              >
                {faculty?.map((row, index) => (
                  <MenuItem value={row} key={index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 1, minWidth: "100%" }}>
              <InputLabel>Select Second Choice Faculty</InputLabel>
              <Select
                value={secondFaculty}
                onChange={(e) => setSecondFaculty(e.target.value)}
                fullWidth
                label="Second Choice Faculty"
              >
                {faculty?.map((row, index) => (
                  <MenuItem value={row._id} key={Math.random() + "-" + index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          */}
        </Grid>

        <Typography variant="body1" className="fw-bold mt-4 mt-lg-4">
          Current Institution attended
        </Typography>

        <Grid container spacing={2} sx={{ mt: 3 }}>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Name of School/University"
                placeholder="Enter The name of your current institution"
                variant="outlined"
                value={currentInstitution}
                onChange={(e) => setCurrentInstitution(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Course of Study"
                placeholder="Enter the course studied"
                variant="outlined"
                value={courseStudied}
                onChange={(e) => setCourseStudied(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="Grade Obtained"
                placeholder="Enter grade obtained"
                variant="outlined"
                value={gradeObtainedFromInstitution}
                onChange={(e) => setGradeObtainedFromInstitution(e.target.value)}
              />
            </FormControl>
          </Grid>

        </Grid>
      </CardContent>

      <CardActions>
        <Grid container spacing={2} className="px-2 w-100">
          <Grid size={{ xs: 6 }}>
            <Button
              variant="outlined"
              color="tertiary"
              fullWidth
              onClick={onPreviousClick}
              sx={{
                py: 1.5,
                mt: 2,
                textTransform: "uppercase",
                borderRadius: 2,
                color: "#000",
              }}
            >
              Previous
            </Button>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleForwardClick}
              sx={{
                py: 1.5,
                mt: 2,
                textTransform: "uppercase",
                borderRadius: 2,
                color: "#fff",
              }}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
